import { types } from '../../../constants/ActionTypes'

const initialState = {
  anchorEl: null,
}

const userMenu = (state = initialState, action) => {
  switch (action.type) {
    case types.router.LOCATION_CHANGE:
      return { ...state, anchorEl: null }
    case types.userMenu.OPEN:
      return { ...state, anchorEl: action.anchorEl }
    case types.userMenu.CLOSE:
      return { ...state, anchorEl: null }
    default:
      return state
  }
}

export default userMenu



// WEBPACK FOOTER //
// ./src/reducers/Common/MenuAppBar/UserMenu.js